import { Bell, LogOut, Menu, Sparkles, X } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../../features/auth/AuthProvider";
import { roleMeta, roleNavigation } from "../navigation";
import { Button } from "../../shared/ui/Button";

export function PortalLayout() {
  const { session, signOut } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  if (!session) return null;
  const { profile } = session;
  const meta = roleMeta[profile.role];
  const nav = roleNavigation[profile.role];
  const noticeTarget =
    profile.role === "member" || profile.role === "employee"
      ? `${meta.basePath}/profile`
      : profile.role === "manager"
        ? `${meta.basePath}/tasks`
        : `${meta.basePath}/system`;
  return (
    <div className={`portal-shell portal-shell--${profile.role}`}>
      <aside className={menuOpen ? "portal-sidebar is-open" : "portal-sidebar"}>
        <div className="sidebar-brand">
          <span>
            <Sparkles />
          </span>
          <div>
            <small>BOOM TENNIS</small>
            <strong>网爆星球 V4</strong>
          </div>
          <button
            className="mobile-close"
            onClick={() => setMenuOpen(false)}
            aria-label="关闭导航"
          >
            <X />
          </button>
        </div>
        <div className="account-summary">
          <span>{meta.label}</span>
          <strong>{profile.name}</strong>
          <small>{profile.storeName ?? "总部 · 全公司"}</small>
        </div>
        <nav aria-label={`${meta.label}主导航`}>
          {nav.map((item, index) => (
            <NavLink
              key={item.path}
              to={`${meta.basePath}/${item.path}`}
              onClick={() => setMenuOpen(false)}
            >
              <i>{String(index + 1).padStart(2, "0")}</i>
              <span>
                <strong>{item.label}</strong>
                <small>{item.description}</small>
              </span>
            </NavLink>
          ))}
        </nav>
        <Button variant="ghost" className="sidebar-logout" onClick={signOut}>
          <LogOut size={17} />
          退出登录
        </Button>
      </aside>
      {menuOpen && (
        <button
          className="nav-scrim"
          onClick={() => setMenuOpen(false)}
          aria-label="关闭导航遮罩"
        />
      )}
      <section className="portal-main">
        <header className="mobile-header">
          <button onClick={() => setMenuOpen(true)} aria-label="打开导航">
            <Menu />
          </button>
          <strong>{meta.label}</strong>
          <NavLink className="mobile-profile-link" to={`${meta.basePath}/profile`} aria-label="打开个人中心">{profile.name.slice(0, 1)}</NavLink>
        </header>
        <header className="desktop-topbar">
          <div className="global-search">
            <span>V4 实时业务工作台</span>
          </div>
          <div className="topbar-actions">
            <NavLink to={noticeTarget} aria-label="打开通知与待办">
              <Bell size={19} />
              <i />
            </NavLink>
            <NavLink className="topbar-profile" to={`${meta.basePath}/profile`} aria-label="打开个人中心">
              <span>{profile.name.slice(0, 1)}</span>
              <div>
                <strong>{profile.name}</strong>
                <small>{profile.storeName ?? "总部"}</small>
              </div>
            </NavLink>
          </div>
        </header>
        <div className="portal-content">
          <Outlet />
        </div>
        <nav className="mobile-bottom-nav" aria-label={`${meta.label}移动导航`}>
          {nav.map((item) => (
            <NavLink key={item.path} to={`${meta.basePath}/${item.path}`}>
              <span>{item.label.slice(0, 1)}</span>
              <small>{item.label}</small>
            </NavLink>
          ))}
        </nav>
      </section>
    </div>
  );
}
